import dayjs from "moment"
import type { AttendanceRecord, ColumnMap } from "./types"

const normalizeDate = (raw: unknown) => {
  if (raw === null || raw === undefined || raw === "") return ""
  if (raw instanceof Date) return dayjs(raw).format("YYYY-MM-DD")
  // Excel serial → JS date (days since 1899-12-31).
  if (typeof raw === "number") {
    const jsDate = new Date(Math.round((raw - 25569) * 86400 * 1000))
    return dayjs(jsDate).format("YYYY-MM-DD")
  }
  const cleaned = String(raw).trim()
  const parsed = dayjs(cleaned)
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : cleaned
}

const pick = (
  row: Record<string, unknown>,
  key: string | null | undefined
) => (key ? String(row[key] ?? "").trim() : "")

export const mapRowsToAttendanceRecords = (
  rows: Record<string, unknown>[],
  columnMap: ColumnMap
): AttendanceRecord[] =>
  rows.map((r) => {
    const rawDate = columnMap.date ? r[columnMap.date] : ""
    const shiftPeriodIdRaw = pick(r, columnMap.shiftPeriodId)
    const shiftPeriodId = Number(shiftPeriodIdRaw)

    return {
      shift_period_id: Number.isNaN(shiftPeriodId) ? 0 : shiftPeriodId,
      date: normalizeDate(rawDate),
      employeeId: pick(r, columnMap.employeeId),
      clockin_time: pick(r, columnMap.clockIn),
      clockout_time: pick(r, columnMap.clockOut),
      clockin_latitude: pick(r, columnMap.clockInLatitude),
      clockout_latitude: pick(r, columnMap.clockOutLatitude),
      clockin_longitude: pick(r, columnMap.clockInLongitude),
      clockout_longitude: pick(r, columnMap.clockOutLongitude),
      flags: [],
    }
  })
